<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>PART I</span></p>
<p class="chap-title-2"><span>THE TABLETS</span></p>
<p class="image-center"><span><img alt="image" class="svg" src="images/fig02-01.jpg"/></span></p>
<p class="normal"><i>The Memorial Hall of Harvard consists of three main divisions: one of them a theatre, for academic ceremonies; another a vast refectory covered with a timbered roof, hung about with portraits and lighted by stained windows … and the third, the most interesting, a chamber high, dim, and severe, consecrated to the sons of the university who fell in the long Civil War</i>.</p>
<p class="right"><span>—H<span class="smallcaps">ENRY</span> J<span class="smallcaps">AMES</span>, <i>T<span class="smallcaps">HE</span> B<span class="smallcaps">OSTONIANS</span></i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1chapter01.vue?1cab7cb5